import axios, { AxiosResponse } from "axios";
import TitleValue from "../../models/dtos/base/TitleValue";
import { CourseExamWorkBooksDTO } from "../../models/dtos/exams/rating-estimates/CourseExamWorkBooksDTO";
import { ExamWorkBooksDTO } from "../../models/dtos/exams/rating-estimates/ExamWorkBooksDTO";
import { WorkBooksDTO } from "../../models/dtos/exams/rating-estimates/WorkBooksDTO";
import { ExamWorkBookQueryString } from "../../models/query-strings/exams/rating-estimates/ExamWorkBookQueryString";
import { WorkBookQueryString } from "../../models/query-strings/exams/rating-estimates/WorkBookQueryString";
import BaseService from "../base/BaseService";

export default class WorkBookService extends BaseService {
    getPaged(queryString: WorkBookQueryString): Promise<WorkBooksDTO[]> {
        return axios.get('/ExamWorkBook', { params: queryString }).then(function (response: AxiosResponse<WorkBooksDTO[], any>) {
            return response.data;
        });
    }

    getWorkBooks(queryString: ExamWorkBookQueryString): Promise<ExamWorkBooksDTO[]> {
        return axios.get('/ExamWorkBook/WorkBooks', { params: queryString }).then(function (response: AxiosResponse<ExamWorkBooksDTO[], any>) {
            return response.data;
        });
    }

    getById(id: string): Promise<TitleValue<number>[]> {
        return axios.get(`/ExamWorkBook/${id}`).then(function (response: AxiosResponse<TitleValue<number>[], any>) {
            return response.data;
        });
    }

}